var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidecollaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8745 22.7105L48.4593 16.2343L39.6583 19.68C39.6583 19.68 39.9074 28.2734 38.3299 31.0964C37.9562 32.4664 32.6839 40.3125 30.3176 40.3956C32.0197 39.7313 36.5032 36.7838 38.3714 32.923C40.2395 29.0622 40.7792 24.2466 40.7792 24.2466L48.8745 22.7105Z",
    fill: "url(#paint0_radial_2688_3051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2236 38.4028C33.2236 38.4028 39.2432 34.625 39.1602 33.5872C40.6962 34.708 46.7988 37.9461 46.7988 37.9461C46.7988 37.9461 42.1077 42.9694 40.6547 43.7581C39.7414 42.8033 34.8842 37.7386 34.8842 37.7386L33.2236 38.4028Z",
    fill: "url(#paint1_radial_2688_3051)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3555 39.7313C31.3555 39.7313 38.1223 35.9535 39.8659 28.481C40.0735 27.3186 40.6131 24.0389 40.6131 24.0389L49.8293 22.5444C49.8293 22.5444 49.5802 27.7752 48.5423 30.2661C47.2139 30.1 40.9452 29.1452 40.9452 29.1452C40.9452 29.1452 37.5826 36.9499 31.3555 39.7313Z",
    fill: "#2771B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5557 38.6935C33.5557 38.6935 39.4922 33.1306 40.6961 28.8961C41.5679 28.9376 48.4593 30.3491 49.8707 30.1C49.8707 30.7227 47.1723 36.8253 46.0514 37.6556C44.806 36.9499 39.4922 33.8778 39.4922 33.8778L33.5557 38.6935Z",
    fill: "#E80980"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8754 18.1854C25.1697 18.1854 24.547 17.8118 24.1733 17.2306C23.8412 16.6079 23.8412 15.9021 24.2148 15.2794C24.5469 14.6567 25.2112 14.2831 25.8754 14.2831C26.5811 14.3246 27.2039 14.6982 27.536 15.2794C27.8681 15.9021 27.9096 16.6079 27.5775 17.2306C27.2039 17.8118 26.5811 18.1854 25.8754 18.1854ZM24.5885 16.9815C24.8791 17.4382 25.3772 17.6872 25.8754 17.6872C26.4151 17.6872 26.8717 17.4382 27.1623 16.9815C27.4114 16.5248 27.4114 15.9436 27.1208 15.487C26.8717 15.0303 26.3736 14.7397 25.8339 14.7397C25.2942 14.7813 24.8376 15.0303 24.547 15.487C24.3394 15.9852 24.3394 16.5248 24.5885 16.9815Z",
    fill: "url(#paint2_radial_2688_3051)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8754 17.8533C25.2942 17.8533 24.7545 17.5627 24.4224 17.0645C24.1318 16.5664 24.1733 15.9436 24.4639 15.404C24.7545 14.9058 25.2942 14.5737 25.8754 14.5737C26.4566 14.5737 26.9963 14.9058 27.2869 15.404C27.5775 15.9021 27.5775 16.5248 27.3284 17.0645C26.9963 17.5627 26.4566 17.8533 25.8754 17.8533Z",
    fill: "url(#paint3_radial_2688_3051)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.7961 16.8569C25.0452 17.2305 25.4603 17.4381 25.8754 17.4796C26.3321 17.4796 26.7472 17.2721 26.9548 16.8569C27.1624 16.4833 27.1624 15.9851 26.9133 15.6115C26.7057 15.2379 26.2906 14.9888 25.8339 14.9473C25.3773 14.9473 25.0036 15.1964 24.7546 15.6115C24.5885 16.0266 24.5885 16.4833 24.7961 16.8569Z",
    fill: "url(#paint4_radial_2688_3051)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8753 17.106C25.5432 17.106 25.2526 16.94 25.0866 16.6909C24.9205 16.4003 24.962 16.0682 25.0866 15.8191C25.2526 15.5285 25.5432 15.3624 25.8338 15.3624C26.1659 15.3624 26.415 15.5285 26.5811 15.8191C26.7471 16.1097 26.7471 16.4418 26.5811 16.6909C26.4981 16.94 26.2075 17.106 25.8753 17.106Z",
    fill: "url(#paint5_radial_2688_3051)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.8754 16.7324C25.6678 16.7324 25.5017 16.6494 25.4187 16.4834C25.3357 16.3173 25.3357 16.1097 25.4187 15.9437C25.5017 15.7776 25.6678 15.6946 25.8754 15.6531C26.0829 15.6531 26.249 15.7776 26.332 15.9437C26.4151 16.1097 26.4151 16.3173 26.332 16.4834C26.249 16.6494 26.0829 16.7324 25.8754 16.7324Z",
    fill: "url(#paint6_radial_2688_3051)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5434 16.1097C25.4604 16.1097 25.4188 16.0682 25.3773 16.0267C25.3358 15.9437 25.3358 15.9021 25.3773 15.8191C25.4188 15.7361 25.5019 15.6946 25.5434 15.6946C25.6264 15.6946 25.6679 15.7361 25.7094 15.8191C25.751 15.9021 25.751 15.9437 25.7094 16.0267C25.6679 16.0682 25.6264 16.1097 25.5434 16.1097Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3026 10.7544C34.3026 10.7544 43.0621 10.5053 48.2514 25.7825C50.161 34.0439 52.1122 39.8974 52.1122 39.8974C52.1122 39.8974 52.0707 43.343 59.9999 43.7997C56.5542 44.9206 35.9632 55.2161 34.6347 36.9914C35.6726 37.5311 43.1451 43.343 45.3454 43.5506C43.9339 42.4297 31.5627 38.2368 34.2611 27.2771C35.299 27.8167 42.1903 34.459 44.5566 35.0402C43.6848 34.1269 31.4381 27.2771 33.846 18.6421C34.6347 18.7251 40.8203 24.205 42.0243 24.5371C43.2282 24.8692 43.2282 24.8692 43.2282 24.8692C41.0279 23.9144 32.5175 18.0194 34.3026 10.7544Z",
    fill: "#E80980"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0793 40.6861L35.2992 37.448L41.6508 44.0903C41.6508 44.0903 35.5067 47.9926 33.5971 47.9096C32.7668 46.6641 30.2344 40.2294 30.2344 40.2294L27.0793 40.6861Z",
    fill: "#E80980"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1282 0.00222695V9.42595C25.1282 9.42595 16.8254 10.2562 14.21 14.2416C12.1343 16.4003 7.2356 22.3784 10.8473 31.8021C11.8437 33.3381 15.2478 40.354 24.7546 41.0598C26.7473 40.8107 30.2345 40.2295 30.2345 40.2295L33.9292 48.6984C33.9292 48.6984 14.9157 55.6313 4.12204 39.2331C2.71056 37.282 -2.18812 29.8509 1.13302 17.5627C2.46147 14.1586 8.10741 -0.205344 25.1282 0.00222695Z",
    fill: "url(#paint7_radial_2688_3051)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6472 41.3482C34.7724 41.3482 42.1698 33.9507 42.1698 24.8255C42.1698 15.7003 34.7724 8.30286 25.6472 8.30286C16.522 8.30286 9.12451 15.7003 9.12451 24.8255C9.12451 33.9507 16.522 41.3482 25.6472 41.3482Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4224 30.3906V21.216C24.4224 21.216 24.713 19.0987 27.3284 19.4309C27.3284 20.0121 27.3284 30.4736 27.3284 30.4736L24.4224 30.3906Z",
    fill: "url(#paint8_radial_2688_3051)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.636 14.9451C28.636 16.5501 27.3349 17.8511 25.73 17.8511C24.125 17.8511 22.824 16.5501 22.824 14.9451C22.824 13.3402 24.125 12.0391 25.73 12.0391C27.3349 12.0391 28.636 13.3402 28.636 14.9451ZM23.4052 14.9451C23.4052 16.2291 24.446 17.2699 25.73 17.2699C27.0139 17.2699 28.0548 16.2291 28.0548 14.9451C28.0548 13.6612 27.0139 12.6203 25.73 12.6203C24.446 12.6203 23.4052 13.6612 23.4052 14.9451Z",
    fill: "url(#paint9_radial_2688_3051)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7298,
    cy: 14.9452,
    r: 2.3248,
    fill: "url(#paint10_radial_2688_3051)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.73,
    cy: 14.9451,
    r: 1.54986,
    fill: "url(#paint11_radial_2688_3051)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7299,
    cy: 14.9451,
    r: 0.968665,
    fill: "#E80980"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9551,
    cy: 14.3639,
    r: 0.387466,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6255 28.302) scale(10.7627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0211 38.7033) scale(5.99527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8185 15.4334) scale(3.91417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2347,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3827,
    stopColor: "#9EA0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7041,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9235,
    stopColor: "#9EA0A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8939 16.2337) scale(1.96325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#5495C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8044,
    stopColor: "#3965AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3053A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8793 16.223) scale(1.2446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8871 16.2287) scale(1.05866)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5039 16.9991) scale(1.06704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9895 25.0768) scale(21.3978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8792 24.9461) scale(4.04892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.73 14.9451) scale(3.09973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9EA0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9EA0A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7298 14.9452) scale(3.00286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2688_3051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.73 14.9451) scale(1.64673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#12445C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidecollaps);
export default __webpack_public_path__ + "static/media/logo_sidecollaps.89384ffb89cf90f8d056170dd459e427.svg";
export { ForwardRef as ReactComponent };